export const popupText = "";
export const popupTitle = "";

export const vertigisUrl = "https://apps.vertigisstudio.com/web/?app=";
export const vertigisStagingUrl = "https://apps-staging.vertigisstudio.com/web/?app=";
export const kartportalBaseUrl = 'https://kartportal-';
export const kartportalBaseDomain = '.hub.arcgis.com/';
export const publikum = 'publikum';
export const useLocalhostApp = "dev";
export const localhost = "http://localhost:3001";
export const storageKey = "esriJSAPIOAuth";
export const storageValue = {"/":{}}

export const popupParameterName = "popupText";
export const popupTitleParameterName = "popupTitle";

export const devEnvs = ['venus.kommunegis.no', 'mars.kommunegis.no'];
export const advancedReleases = ['innlandet.kommunegis.no', 'kongsberg.kommunegis.no', 'sigdal.kommunegis.no', 'flesberg.kommunegis.no', 'rollag.kommunegis.no', 'noreoguvdal.kommunegis.no','nore-og-uvdal.kommunegis.no', 'kroedsherad.kommunegis.no', 'notodden.kommunegis.no', 'hjartdal.kommunegis.no']
export const blogs = {
    "2": "https://dokumentasjon.kommunegis.no/blog/release2.0",
    "3": "https://dokumentasjon.kommunegis.no/blog/release3.0",
    "undefined": "https://dokumentasjon.kommunegis.no/blog",
    "null": "https://dokumentasjon.kommunegis.no/blog",
}
